"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRulesAsync = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.fetchRulesAsync = (0, typesafe_actions_1.createAsyncAction)(constants_1.FETCH_RULES_REQUEST, constants_1.FETCH_RULES_SUCCESS, constants_1.FETCH_RULES_FAILED, constants_1.FETCH_RULES_CANCEL)();